import Button from "src/components/Button";

export default function MainContentHeader({title,isButton,buttonTitle,clickHandle}) {
    return (
        <div className="flex flex-col h-16 items-start justify-between pb-6 space-y-4 border-b lg:items-center lg:space-y-0 lg:flex-row">
            <h1 className="text-xl font-base whitespace-nowrap">
                {title}
            </h1>
            {isButton ? <Button title={buttonTitle} clickHandle={clickHandle}/> : null}
        </div>
    )
}